import { render, staticRenderFns } from "./invite-dialog.vue?vue&type=template&id=6dc09dda&scoped=true"
import script from "./invite-dialog.vue?vue&type=script&lang=js"
export * from "./invite-dialog.vue?vue&type=script&lang=js"
import style0 from "./invite-dialog.vue?vue&type=style&index=0&id=6dc09dda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc09dda",
  null
  
)

export default component.exports